import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_144: FaireProductEntity = {
  token: "legacy_prod_abbott-144",
  type: "product",
  name: "Candy Cane Room Spray-100ml",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/89d73a95bb1062fb493874aa3f3d7f508014181a1f38b20da8c343525e4290fd.jpeg",
  priceDollars: 14,
  subcategory: "Room Sprays",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_home-fragrances"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
